document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.tab');
  var contents = document.querySelectorAll('.tab-content');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = document.getElementById(tab.getAttribute('data-tab'));

      tabs.forEach(function (item) {
        item.classList.remove('active');
      });

      contents.forEach(function (content) {
        content.classList.remove('active');
      });

      tab.classList.add('active');
      target.classList.add('active');
    });
  });
});
